import React from 'react'
import PropTypes from 'prop-types'

import './formTitle.scss'

class FormTitleComponent extends React.Component {
    render() {
        return <div className="formTitle">
            <h3>{this.props.title}</h3>
        </div>
    }
}

FormTitleComponent.propTypes = {
    title: PropTypes.string.isRequired,
}

export default FormTitleComponent



// WEBPACK FOOTER //
// ./src/components/core/FormTitleComponent/FormTitleComponent.js